import { LAMPORTS_PER_SOL } from '@solana/web3.js'

export const CHAIN_SWAP_LIST: Record<
  string,
  {
    // 精度
    decimals: number
    // 符号
    symbol: string
    // 合约地址
    tokenAddress: string
    // 链id
    chainId?: string
    // eip155链id
    eip155ChainId?: string
  }
> = {
  solana: {
    decimals: LAMPORTS_PER_SOL,
    symbol: 'SOL',
    tokenAddress: '11111111111111111111111111111111',
  },
  ethereum: {
    decimals: 18,
    symbol: 'ETH',
    chainId: '0x1',
    eip155ChainId: 'eip155:1',
    tokenAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  },
  base: {
    decimals: 18,
    symbol: 'ETH',
    chainId: '0x2105',
    eip155ChainId: 'eip155:8453',
    tokenAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  },
  bsc: {
    decimals: 18,
    symbol: 'BNB',
    chainId: '0x38',
    eip155ChainId: 'eip155:56',
    tokenAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  },
  arbitrum: {
    decimals: 18,
    symbol: 'ETH',
    chainId: '0xA4B1',
    eip155ChainId: 'eip155:42161',
    tokenAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  },
  tron: {
    decimals: 6,
    symbol: 'TRX',
    tokenAddress: 'T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb',
  },
}

export const DEFAULT_CHAIN_LIST: Record<
  string,
  {
    name: string
    symbol: string
    chainId: string
    image_url: string
    contract_address: string
    websites: string[]
    twitterHandle: string | null
    telegramHandle: string | null
    discordUrl: string | null
  }
> = {
  solanaTrump: {
    name: 'OFFICIAL TRUMP',
    symbol: 'TRUMP',
    chainId: 'solana',
    image_url: 'https://coin-images.coingecko.com/coins/images/53746/large/trump.png?1737171561',
    contract_address: '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN',
    websites: ['https://gettrumpmemes.com'],
    twitterHandle: 'realDonaldTrump',
    telegramHandle: null,
    discordUrl: null,
  },
  solana: {
    name: 'USD Coin',
    symbol: 'USDC',
    chainId: 'solana',
    image_url: 'https://coin-images.coingecko.com/coins/images/6319/large/usdc.png?1696506694',
    contract_address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    websites: ['https://www.circle.com/en/usdc'],
    twitterHandle: 'circle',
    telegramHandle: null,
    discordUrl: 'https://discord.com/invite/buildoncircle',
  },
  ethereum: {
    name: 'SHIBA INU',
    symbol: 'SHIB',
    chainId: 'ethereum',
    image_url: 'https://coin-images.coingecko.com/coins/images/11939/large/shiba.png?1696511800',
    contract_address: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
    websites: ['https://shibatoken.com', 'https://shib.io'],
    twitterHandle: 'circle',
    telegramHandle: null,
    discordUrl: 'https://discord.com/invite/buildoncircle',
  },
  base: {
    name: 'BasedPepe',
    symbol: 'PEPE',
    chainId: 'base',
    image_url: 'https://coin-images.coingecko.com/coins/images/39763/large/based_pepe_transparent.png?1724010222',
    contract_address: '0x52b492a33e447cdb854c7fc19f1e57e8bfa1777d',
    websites: ['https://basedpepe.vip'],
    twitterHandle: 'circle',
    telegramHandle: null,
    discordUrl: 'https://discord.com/invite/buildoncircle',
  },
  bsc: {
    name: '币安人生',
    symbol: '币安人生',
    chainId: 'bsc',
    image_url:
      'https://coin-images.coingecko.com/coins/images/69848/large/%E5%B8%81%E5%AE%89%E4%BA%BA%E7%94%9F.png?1759839225',
    contract_address: '0x924fa68a0fc644485b8df8abfa0a41c2e7744444',
    websites: ['https://www.circle.com/en/usdc'],
    twitterHandle: 'circle',
    telegramHandle: null,
    discordUrl: 'https://discord.com/invite/buildoncircle',
  },
  arbitrum: {
    name: 'Pege',
    symbol: 'PEPE',
    chainId: 'arbitrum',
    image_url: 'https://coin-images.coingecko.com/coins/images/29850/large/pepe-token.jpeg?1696528776',
    contract_address: '0x25d887ce7a35172c62febfd67a1856f20faebb00',
    websites: ['https://www.pepe.vip'],
    twitterHandle: 'circle',
    telegramHandle: null,
    discordUrl: 'https://discord.com/invite/buildoncircle',
  },
  tron: {
    name: 'Tether USD',
    symbol: 'USDT',
    chainId: 'tron',
    image_url: 'https://coin-images.coingecko.com/coins/images/325/large/Tether.png?1696501661',
    contract_address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
    websites: ['https://tether.to'],
    twitterHandle: 'Tether_to',
    telegramHandle: null,
    discordUrl: null,
  },
}
